import type { FunctionComponent } from 'react';
import useFinanceFooter from './useFooter';

export interface FinanceFooterProps {
  amount?: number;
  apr?: number;
  terms?: number;
  marginClassName?: string;
}

const FinanceFooter: FunctionComponent<FinanceFooterProps> = function ({
  amount,
  apr,
  terms,
  marginClassName = 'mt-4 md:mb-8 ',
}) {
  const { year, loan, interest, monthly, total, duration } = useFinanceFooter(
    amount,
    apr,
    terms,
  );
  const className = [
    'z-50 flex w-full px-4 py-2 mx-auto text-center max-w-256 text-14-22 text-neutral-600 mb-4',
    marginClassName,
  ].join(' ');
  return (
    <div className={className}>
      <div className="flex flex-col items-center justify-center">
        <p className="text-center">
          {`© ${year} Ideal Sales Solutions Limited is a licensed credit broker and not a lender.
Ideal Sales Solutions Ltd is authorised and regulated by the Financial Conduct Authority. Firm Reference Number 703401. VAT Number GB975327880.
Registered in England with Companies House - Company Registration Number: 06724294 Registered with the ICO under registration number Z1790314. Credit is subject to status.
          Representative example: ${interest} APR Representative based on a loan of
          ${loan} repayable over ${duration} months at an interest rate of ${interest} PA
          (fixed). Monthly repayment of ${monthly}. Total amount payable ${total}.`}
        </p>
      </div>
    </div>
  );
};

export default FinanceFooter;
